import styled, { css } from "styled-components";
import InfiniteScrollComponent from "react-infinite-scroll-component";
import { Button as ButtonComponent } from "ui";
import DropdownComponent from "ui/Dropdown";
import SearchIcon from "core/icons/SearchIcon.svg";
import { disabledStyle } from "core/styles/fieldStyle";
import { scrollerStyle } from "core/styles/scrollerStyle";
import EmptyDataSmileComponent from "ui/EmptyDataSmile";
import CrossSvg from "core/icons/cross/cross2.svg?react";

export const Container = styled.div<{ width?: string; height?: string }>`
  position: relative;
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "40px"};

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const FormatCurrency = styled.div<{ isDisabled?: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 16px;
  line-height: 24px;
  color: ${({ isDisabled, theme }) =>
    isDisabled ? theme?.colors?.neutral.neutral60 : theme?.colors?.neutral.neutral100};
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "text")};
`;

export const InputStyle = styled.input<{
  error?: string;
  searchPosition?: string;
  search?: boolean;
  theme?: { variant?: string };
  withSideButton?: boolean;
  disabled: boolean;
}>`
  border: 2px solid
    ${({ error, theme }) =>
      error ? theme?.colors?.dangerv2.border : theme?.colors?.neutral.neutral30};
  border-radius: 8px;
  width: 100%;
  height: 100%;
  font-family: Nunito-Sans;
  font-size: 14px;
  line-height: 30px;
  padding: ${({ search, searchPosition, theme }) => {
    if (search && searchPosition === "start") return "0px 24px 0px calc(5% + 28px)";
    if (search && searchPosition === "end") return "0px calc(5% + 28px) 0px 24px";
    if (theme?.variant === "currency") return "8px 16px 8px 40px";
    if (theme?.variant === "phone_number") return "8px 16px 8px 111px";
    return "8px 16px";
  }};
  background-image: ${(props) => (props as any).search && `url(${SearchIcon})`};
  background-repeat: no-repeat;
  background-position-x: ${(props) => ((props as any).searchPosition === "start" ? "5%" : "95%")};
  background-position-y: 50%;
  color: ${({ theme }) => theme?.colors?.neutral.neutral90};

  &::placeholder {
    color: ${({ theme }) => theme?.colors?.neutral.neutral60};
  }

  ${disabledStyle}

  &:focus {
    outline: none;
    border: 2px solid ${({ theme }) => theme?.colors?.primary.border};
    border-radius: 8px;
  }

  ${({ withSideButton }) =>
    withSideButton &&
    css`
      border-radius: 8px 0px 0px 8px;
      border-right: none;

      &:focus {
        border-radius: 8px 0px 0px 8px;
      }
    `}
`;

export const ErrorMessage = styled.div<{ errorPosition?: "left" | "right" }>`
  width: max-content;
  font-family: Nunito-Sans-SemiBold;
  font-size: 12px;
  margin-top: 2px;
  color: ${({ theme }) => theme?.colors?.dangerv2.default};
  margin-right: ${({ errorPosition }) => errorPosition === "left" && "auto"};
  margin-left: ${({ errorPosition }) => errorPosition === "right" && "auto"};
  white-space: pre-line;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;
`;

export const SideButton = styled(ButtonComponent)`
  display: flex;
  width: fit-content;
  padding: 8px 16px;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  height: 100%;
  border-radius: 0px 8px 8px 0px;
  box-sizing: border-box;
`;

export const SearchResultContainer = styled.div<{ isLarger?: boolean }>`
  z-index: 5;
  width: 500px;
  height: 410px;
  border-radius: 8px;
  position: absolute;
  top: 44px;
  left: 0px;
  background-color: ${({ theme }) => theme?.colors?.white};
  box-shadow: 0px 4px 8px 0px #0000001a;
  padding: 16px;

  .infinite-scroll-component__outerdiv {
    display: flex;
    height: ${({ isLarger }) => (isLarger ? "calc(100% - 24px)" : "calc(100% - 78px)")};
  }
`;

const searchListStyle = css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: ${({ isLarger }: { isLarger?: boolean }) =>
    isLarger ? "calc(100% - 36px)" : "calc(100% - 98px)"};

  overflow-y: scroll;
  margin-bottom: 24px;

  ${scrollerStyle}
`;

export const SearchList = styled.div`
  ${searchListStyle}
`;

// @ts-expect-error TS(2769): No overload matches this call.
export const InfiniteScroll = styled(InfiniteScrollComponent)`
  ${searchListStyle}
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid ${({ theme }) => theme?.colors?.neutral.neutral40};
  padding-top: 10px;
`;

export const EmptyDataSmile = styled(EmptyDataSmileComponent)`
  min-height: 0px;
  padding-top: 30px;

  img {
    height: 160px;
  }

  .empty-data-title {
    font-size: 16px;
  }

  .empty-data-text {
    font-size: 14px;
  }
`;

export const CrossIcon = styled(CrossSvg)`
  position: absolute;
  right: 15px;
  cursor: pointer;

  path {
    stroke: ${({ theme }) => theme?.colors?.neutral.neutral60};
  }
`;

export const Dropdown = styled(DropdownComponent)`
  .dropdown-header {
    gap: 4px;
    border: none;
  }

  .dropdown-angle {
    margin: 0;
  }
`;

export const CountryCodeContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  gap: 8px;
  left: 16px;
  top: 8px;
  z-index: 1;
`;
